import React, { useState } from "react";
import "./forgot.css";
import "../color.css";
import strings from "../../utils/property-file/forgot.json";
import emailString from "../../utils/property-file/emailInput.json";
import { useNavigate } from "react-router-dom";
import auth from "../../services/auth";
import Ripple from "../button/ripple";
import CustomDialog from "../customDialog";
import constants from "../../utils/constants";
import { toast } from "react-toastify";

export default function Forgot() {

  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [passwordLoaderForgot ,setPasswordLoaderForgot] = useState(false);
  const [onSuccess, setOnSuccess] = useState(false);
  const forgotPassword = async (e) => {
    setPasswordLoaderForgot(true);
    e.preventDefault();
    try {
      let body = {
        email: email,
      };
      let response = await auth.forgotPassword(body);
      if(response)
      {
        if (response.success) {
          setOnSuccess(true);
          setPasswordLoaderForgot(false);
        }
        else {
          setPasswordLoaderForgot(false);
          const data = JSON.parse(response.data)
          toast.error(data?(data.body ? data.body : strings.error_msg):strings.error_msg, { toastId: "error14" });
        }
      }
      else{
        setPasswordLoaderForgot(false);
      }
    } catch (error) {
      setPasswordLoaderForgot(false);
     
    }
  };
  return (
    <>
      {onSuccess ? (
        <CustomDialog />
      ) : (
        <div className="whole-Form">
          <div
            className="arrow"
            onClick={() => {
              nav(constants.navigationLink.loginLink);
            }}
          >
            <i className="ri-arrow-left-line line"></i>
          </div>
          <div className="main-container row">
            <div className="forgot-container col-12">
              <div className="locker mt-5">
                <i className="ri-lock-password-line fa-2x text-light text-center d-block"></i>
              </div>
              <div className="company-page-heading">
                <h4 className="mt-3">{strings.Forgot_Password}</h4>
                <p>
                  {strings.Forgot_Password_Page_Desc}
                </p>
              </div>
            </div>
            <form className="input" onSubmit={forgotPassword}>
              <div className="email-btn ">
                <div className="form-floating mb-3 email-up-div">
                  <input
                    name="email"
                    type="email"
                    onChange={(e) => {
                      setEmail(e.target.value)
                    }}
                    value={email}
                    className="form-control validateEmail email-input pb-0"
                    id="email"
                    placeholder=" "
                    required
                    autoComplete="off"
                  />
                  <label htmlFor="floatingInput" className="text-light input-place">
                    {emailString.place_holder_email}
                  </label>
                </div>
              </div>
              <div className="button-submit mb-5">
                <button
                  disabled={passwordLoaderForgot ? true :false}
                  type="submit"
                  className="btn btn-primary text-center mt-4 forgot-submit-btn">
                  {passwordLoaderForgot ?( <div className="spinner-border spinner-border-sm text-light" role="status">
                  <span className="sr-only"></span>
                   </div>):strings.submit} 
                   <Ripple duration={1000} />
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
